module.exports = __webpack_public_path__ + "0ffbe710827d3846712bf35147aeb9a9.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/NanumGothicBold.eot
// module id = 590
// module chunks = 0